<template>
  <div class="home">
    <div style="      width: 70%;    margin: auto;">
    
 
     <md-button class="md-raised md-primary" @click="$router.push('sign')">Signature Pad</md-button>
     <md-button class="md-raised md-primary" @click="$router.push('field')">Sign Text field</md-button>
     <md-button class="md-raised md-primary" @click="generateCode()">Generate Code</md-button>
     <div v-if="!!code">
       <div style=" font-size: 40px;    text-align: center;    margin-top: 25px;    margin-bottom: 25px">{{code}}</div>

          <div style="    font-size: 20px;
    text-align: center;

    color: gray">Expiration date:</div> 

          <div style="    font-size: 20px;
    text-align: center;

    color: gray">{{date}}</div>
        
     </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: 'Generate',
  components: {
  },
  data(){
return {
  code:'',
  date: ''
}
  },
  methods:{
    generateCode(){
      var vm=this;
 axios.post('https://cartago-2fa.herokuapp.com/api/code/generate',{
                  user_id: 1
                })
      .then(response => { vm.code=response.data.code;
      vm.date=response.data.expiredDate;
      })
    }
  }
}
</script>
